export default function AcademicCap({ fill = "#004E99"}) {
  return (
    <>
      <svg
        width="14"
        height="12"
        viewBox="0 0 14 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.79208 0.826996L0.455078 4.284L6.79208 7.741L11.9771 4.912V8.893H13.1291V4.284M2.75508 6.692V8.992L6.78808 11.192L10.8211 8.992V6.692L6.78808 8.892L2.75508 6.692Z"
          fill={fill}
        />
      </svg>
    </>
  );
}
